export default __webpack_public_path__ + "static/media/type-h1.4c6eb94d.svg";